import cx from 'classnames'
import React from 'react'

type Props = {
  /** External classnames applied to the list */
  className?: string
  /** Child elements */
  children: React.ReactNode
}

/** Creates a list component where the contents of the list are added and removed
 * from the list with an animation.
 */
const AnimatedList: React.FC<Props> = ({
  className,
  children,
}: Props): React.ReactElement => {
  return <ul className={cx('m-0 list-none p-0', className)}>{children}</ul>
}

export default AnimatedList
